import api from "./api";

export type CompanyDto = {
  id: string;
  name: string;
  code: string;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  gstin?: string | null;
  pan?: string | null;
  stateCode?: string | null;
  businessType?: string | null;
  dlNumber?: string | null;
  fssaiNumber?: string | null;
  country?: string | null;
  currencyCode?: string | null;
  currencySymbol?: string | null;
  currencyPosition?: "prefix" | "suffix" | null;
  currencyDecimals?: number | null;
  taxRegime?: "GST" | "VAT" | "SALES_TAX" | "CUSTOM" | null;
  taxLabel?: string | null;
  taxNumberLabel?: string | null;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export interface CompanyListParams {
  pageNo?: number;
  pageSize?: number;
  search?: string;
  isActive?: boolean | string;
}

export const companyAPI = {
  list: async (
    params?: CompanyListParams
  ): Promise<{ data: CompanyDto[]; total: number }> => {
    const response = await api.get("/companies", { params });
    const raw = response.data?.data;
    const total =
      response.data?.options?.metaData?.total ??
      response.data?.metaData?.total ??
      (Array.isArray(raw) ? raw.length : 0);
    return {
      data: Array.isArray(raw) ? raw : [],
      total: Number(total) || 0,
    };
  },

  getById: async (id: string) => {
    const response = await api.get(`/companies/${id}`);
    return response.data.data as CompanyDto;
  },

  create: async (body: {
    name: string;
    code?: string;
    email?: string;
    phone?: string;
    address?: string;
    gstin?: string;
    pan?: string;
    stateCode?: string;
    businessType?: string;
    dlNumber?: string;
    fssaiNumber?: string;
    adminName?: string;
    adminEmail?: string;
    adminPassword?: string;
    adminPhone?: string;
  }) => {
    const response = await api.post("/companies", body);
    return response.data.data;
  },

  update: async (id: string, body: Partial<CompanyDto>) => {
    const response = await api.put(`/companies/${id}`, body);
    return response.data.data as CompanyDto;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/companies/${id}`);
    return response.data.data;
  },
};

